import formatPrice from "@/lib/formatPrice";
import styles from "@/styles/Price.module.scss";

export default function NonTrialFormatPriceSVOD({ price, ext }) {
  return (
    <span className={`${styles.price} ${styles.svod}`}>
      <span className={styles.slate}>
        月額：
        <span className={styles.bold}>{formatPrice(price)}円</span>
        （税込）
        {ext}
      </span>
    </span>
  );
}
